import React, { useContext } from 'react';
import { PageContext } from '../providers/page-provider';
import { HealthAssesment } from '../providers/health-assesment-provider';

import { HealthAssesmentCalculator } from '../layouts/health-assesment-calculator';
import './pages.scss';
import {
  Question,
  StepSummary,
  ButtonOption,
  StepSlider
} from '../components'

export const StepFour = () => {
  const { handleNextPage, handlePreviousPage } = useContext(PageContext);
  const { addHealthAssesmentData, healthAssesmentData } = useContext(HealthAssesment);
  const titleStep = "Resilience";
  const summaryStep = "Last step, let's take a look at some key factors in your operations and team";
  const tooltip = "Resiliency measures the ability of your business to mitigate factors that are outside of your direct control and how likely your business can withstand sudden and prolonged changes."
  const handleNextClick = () => {
    handleNextPage({from: "STEP_FOUR", to: "STEP_FIVE"});
  };

  const handleBackClick = () => {
    handlePreviousPage({to: "STEP_THREE"});
  };

  const handleChange = (question) => (event) => {
    const { name, value } = event.target;
    addHealthAssesmentData({question, name, value});
  };

  return (
    <HealthAssesmentCalculator>
      <div className="fieldset step-four">
        <StepSummary stepNumber="4" stepTitle={titleStep} stepInfo={summaryStep} hasTooltip={true} tooltipText={tooltip}/>
        <div className="questions">
          <div className="column-left">
            <Question>Do you pass on the credit card fees to your payers?</Question>
            <div className="btn-container">
              <ButtonOption
                name="a"
                checked={healthAssesmentData.resilience.a === "yes"}
                onChange={handleChange("resilience")}
                value="yes"
                id="feesYes"
              />

              <ButtonOption
                name="a"
                checked={healthAssesmentData.resilience.a === "no"}
                onChange={handleChange("resilience")}
                value="no"
                id="feesNo"
              />
            </div>

            <Question>In case of natural disaster, can you conduct your AR operation 100% remotely?</Question>
            <div className="btn-container">
              <ButtonOption
                name="b"
                checked={healthAssesmentData.resilience.b === "yes"}
                onChange={handleChange("resilience")}
                value="yes"
                id="remotelyYes"
              />

              <ButtonOption
                name="b"
                checked={healthAssesmentData.resilience.b === "no"}
                onChange={handleChange("resilience")}
                value="no"
                id="remotelyNo"
              />
            </div>

            <Question>Are you financing against receivables?</Question>
            <div className="btn-container">
              <ButtonOption
                name="c"
                checked={healthAssesmentData.resilience.c === "yes"}
                onChange={handleChange("resilience")}
                value="yes"
                id="receivablesYes"
              />

              <ButtonOption
                name="c"
                checked={healthAssesmentData.resilience.c === "no"}
                onChange={handleChange("resilience")}
                value="no"
                id="receivablesNo"
              />
            </div>
          </div>
          <div className="column-right">
            <div className="right-container">
              <Question>How many people are on your AR team?</Question>
              <StepSlider
                min={1}
                max={12}
                minValue="<1"
                maxValue="12+"
                currency={false}
                valueType=""
                name="d"
                initalValue={healthAssesmentData.resilience.d}
                onChange={handleChange("resilience")}
                idSlider="4d-slide"
                idValue="4d-value"
              />

              <Question>What is your AR team’s retention rate across the past four quarters?</Question>
              <StepSlider
                min={1}
                max={100}
                minValue="1%"
                maxValue="100%"
                currency={false}
                valueType="%"
                name="e"
                initalValue={healthAssesmentData.resilience.e}
                onChange={handleChange("resilience")}
                idSlider="4e-slide"
                idValue="4e-value"
              />
            </div>
          </div>

          <footer>
            <button className="btn-white-normal-back" onClick={handleBackClick}><i className="fa fa-angle-left"></i> Back</button>
            <button className="btn-white-normal" onClick={handleNextClick}>Next Step <i className="fa fa-angle-right"></i></button>
          </footer>
        </div>
      </div>
    </HealthAssesmentCalculator>
  )
}
